// Copyright (c) Docugami, Inc. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UpgradeModalDisplayProps {
    visible: boolean;
    title: string;
    subText: string;
}

interface AddDocsModalState {
    isOpen: boolean;
    docSetId?: string;
}

interface DisplayState {
    navigationBarVisible: boolean;
    upgradeModalDisplayProps: UpgradeModalDisplayProps;
    addDocsModalState: AddDocsModalState;
    docsetRefreshKeys: { [docsetId: string]: number };
}

export const displaySlice = createSlice({
    name: 'display',
    initialState: {
        navigationBarVisible: true,
        addDocsModalState: {
            isOpen: false
        },
        docsetRefreshKeys: {}
    } as DisplayState,
    reducers: {
        setNavigationBarVisibility(state, action: PayloadAction<boolean>) {
            state.navigationBarVisible = action.payload;
        },
        hideUpgradeModal(state, action: PayloadAction<void>) {
            state.upgradeModalDisplayProps.visible = false;
        },
        setUpgradeModalDisplayProps(state, action: PayloadAction<UpgradeModalDisplayProps>) {
            state.upgradeModalDisplayProps = action.payload;
        },
        setAddDocsVisibility(state, action: PayloadAction<boolean>) {
            state.addDocsModalState.isOpen = action.payload;
        },
        setAddDocsModalState(state, action: PayloadAction<Partial<AddDocsModalState>>) {
            state.addDocsModalState = { ...state.addDocsModalState, ...action.payload };
        },
        refreshDocsetDocuments(state, action: PayloadAction<string>) {
            state.docsetRefreshKeys[action.payload] = Date.now();
        }
    }
});

export const {
    setNavigationBarVisibility,
    hideUpgradeModal,
    setUpgradeModalDisplayProps,
    setAddDocsVisibility,
    setAddDocsModalState,
    refreshDocsetDocuments
} = displaySlice.actions;